<template>
  <div class="wrapper">
    <p class="message-date">{{ messageDate }}</p>
    <div class="row">
      <div class="col my-auto">
        <h4 class="name"><span v-if="computedUnread > 0" class="number-unread">({{ numberUnread }})</span> {{ shortenedName }}</h4>
        <p class="no-margin">{{ shortenedSubject }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
    conversationId: String,
    profileImage: String,
    name: String,
    subject: String,
    messageDate: String,
    numberUnread: Number,
    activeConversationId: String
  },
  computed: {
    shortenedSubject () {
      if (this.subject.length <= 20) return this.subject
      else return this.subject.substring(0, 17) + '...'
    },
    computedUnread () {
      return this.numberUnread
    },
    shortenedName () {
      if (this.name.length <= 16) return this.name
      else return this.name.substring(0, 13) + '...'
    },
    imageUrl () {
      return ''
    }
  }
}
</script>

<style scoped>
.wrapper {
  position: relative !important;
  min-height: 100px;
}

.row {
  height: 100%;
  min-height: 100px;
}

.name, .no-margin {
  padding-left: 1rem;
}

.no-margin {
  margin-bottom: 0px;
}

.message-date {
  position: absolute;
  right: 1rem;
  bottom: .1rem;
}

.number-unread {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/shared/messaging/Thread.vue